import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import Button from '../../../../components/Button'
import Title from '../../../../components/Title'
import usePrivateApi from '../../../../hooks/usePrivateApi'
import { useState } from 'react'
import { format } from 'date-fns'

const WhiteLabelCreditCheckoutSuccess = () => {
  const [sessionId, setSessionId] = useState(null)
  const [isPaid, setIsPaid] = useState(null)
  const [lastRefresh, setLastRefresh] = useState(null)

  const [{ res, success, error, isLoading }, { sendRequest, resetSuccess }] =
    usePrivateApi()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const sessionId = params.get('session_id')
    setSessionId(sessionId)
    sendRequest({ url: `/billing/credits/checkout/${sessionId}/status` })
  }, [sendRequest])

  useEffect(() => {
    if (success) {
      if (isPaid !== null) {
        setLastRefresh(new Date())
      }

      setIsPaid(res.data.paid)
      resetSuccess()
    }
  }, [success, resetSuccess, res, isPaid])

  const refetchSession = () => {
    sendRequest({ url: `/billing/credits/checkout/${sessionId}/status` })
  }

  if (error) {
    return (
      <>
        <Title title="Credit purchase" />
        <div className="max-w-5xl mx-auto px-4">
          <h3 className="text-xl font-semibold tracking-tighter mt-4">
            Error checking payment status
          </h3>
          <p className="text-sm text-gray-600 mt-2 mb-6">
            There was an error checking your payment. Please contact your master
            dealer.
          </p>
        </div>
      </>
    )
  }

  if (isPaid === null) {
    return (
      <div className="flex items-center justify-center p-12 flex-1">
        <span className="spinner" />
      </div>
    )
  }

  if (isPaid === false) {
    return (
      <>
        <Title title="Credit purchase" />
        <div className="max-w-5xl mx-auto px-4">
          <h3 className="text-xl font-semibold tracking-tighter mt-4">
            Payment pending
          </h3>
          <p className="text-sm text-gray-600 mt-2 mb-6">
            You will receive your credits once your payment has cleared. Click
            the button below to check if your payment has cleared.
          </p>
          <div className="mt-6">
            <Button
              color="primary"
              onClick={refetchSession}
              disabled={isLoading}
            >
              Check payment status
            </Button>
            {lastRefresh && (
              <p className="text-sm mt-4 text-gray-700">
                Last checked: {format(lastRefresh, 'dd MMM yyyy at hh:mm')}
              </p>
            )}
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <Title title="Credit purchase" />
      <div className="max-w-5xl mx-auto px-4">
        <h3 className="text-xl font-semibold tracking-tighter mt-4">
          Checkout success
        </h3>
        <p className="text-sm text-gray-600 mt-2 mb-6">
          Your purchase has been successful.
        </p>
        <div className="mt-6 space-x-4">
          <Button as={Link} color="primary" to="/uploads">
            Go to uploads
          </Button>
        </div>
      </div>
    </>
  )
}

export default WhiteLabelCreditCheckoutSuccess
